<template lang="pug">
.outing-detail-needs-meals-table-component
  b-table(
    :items="_value"
    :fields="fields"
    sticky-header
    no-border-collapse
    table-class="basic-table"
  )
    //- セル：日
    template(#cell(date)="row")
      .date-text {{ getDate(row.item.datetime) }}
    //- セル：食事キャンセル・朝食
    template(#cell(breakfast)="row")
      .meal-text(:class="getNeedMealClass(row.item, 'breakfast')") {{ getMeal(row.item, 'breakfast') }}
    //- セル：食事キャンセル・昼食
    template(#cell(lunch)="row")
      .meal-text(:class="getNeedMealClass(row.item, 'lunch')") {{ getMeal(row.item, 'lunch') }}
    //- セル：食事キャンセル・おやつ
    template(#cell(snack)="row")
      .meal-text(:class="getNeedMealClass(row.item, 'snack')") {{ getMeal(row.item, 'snack') }}
    //- セル：食事キャンセル・夕食
    template(#cell(dinner)="row")
      .meal-text(:class="getNeedMealClass(row.item, 'dinner')") {{ getMeal(row.item, 'dinner') }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { NeedsMeal } from "@/commons/services/Outings";

/**
 * ### 外出外泊届け詳細 食事キャンセルテーブルコンポーネント
 */
@Component({})
export default class OutingDetailNeedsMealsTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<OutingDetailNeedsMealsTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<OutingDetailNeedsMealsTableField>;

  get _value(): Array<OutingDetailNeedsMealsTableItem> {
    return this.value;
  }

  /**
   * ### 日付(yyyy年mm月dd日)を返す
   * */
  public getDate(date: number): string {
    return this.$dateUtil.convertNumberToString(date, "mm/dd");
  }

  /**
   * ### 食事の必要可否のCSSクラスを返す
   */
  public getNeedMealClass(item: OutingDetailNeedsMealsTableItem, mealType: MealType): string {
    return item.needsMeal[mealType] ? "need" : "unnecessary";
  }

  /**
   * ### 食事キャンセル情報を返す
   */
  public getMeal(item: OutingDetailNeedsMealsTableItem, mealType: MealType): string {
    return item.needsMeal[mealType] ? "〇" : "×";
  }
}

/** テーブルの列名の情報 */
export interface OutingDetailNeedsMealsTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface OutingDetailNeedsMealsTableItem {
  /** 日付（時間以降は0が格納される17桁） */
  datetime: number;
  /** 食事キャンセル情報 */
  needsMeal: NeedsMeal;
}

export enum MealType {
  /** 朝食 */
  BREAKFAST = "breakfast",
  /** 昼食 */
  LUNCH = "lunch",
  /** おやつ */
  SNACK = "snack",
  /** 夕食 */
  DINNER = "dinner"
}
</script>
